import { render, staticRenderFns } from "./LeadRelinkDialog.vue?vue&type=template&id=f81daef0"
import script from "./LeadRelinkDialog.vue?vue&type=script&lang=ts"
export * from "./LeadRelinkDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports